// extracted by mini-css-extract-plugin
export default {"rootSkeleton":"SkelentonCardSubject_rootSkeleton__VE0pW","rootRegtangle":"SkelentonCardSubject_rootRegtangle__+Gj8-","imgActive":"SkelentonCardSubject_imgActive__bEznW"};